import { render, staticRenderFns } from "./MasterArtwork.vue?vue&type=template&id=0661f095&"
import script from "./MasterArtwork.vue?vue&type=script&lang=js&"
export * from "./MasterArtwork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports